import moment from 'moment';
export default {
    add:{
        date_operation:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            },
            datetime: {
                dateOnly: true,
                latest:moment().format('YYYY-MM-DD'),
                message :"date incorrect"
            }
        },
        operation:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            }
        },
        type_brique:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            }
        },
        quantite:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            },
            numericality:{
                greaterThan:-1,
                message:" doit être superieur à 0"
            },
        },        
    }
}